import { render } from "./KSDeleteCluster.vue?vue&type=template&id=d337af0e"
import script from "./KSDeleteCluster.vue?vue&type=script&lang=js"
export * from "./KSDeleteCluster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__